var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 40,
    viewBox: "0 0 43 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 3.271C43 4.75808 41.7996 5.9585 40.3125 5.9585H2.6875C1.20042 5.9585 0 4.75808 0 3.271C0 1.78391 1.20042 0.583496 2.6875 0.583496H40.3125C41.7996 0.583496 43 1.78391 43 3.271ZM25.9792 32.8335H17.0208C15.5337 32.8335 14.3333 34.0339 14.3333 35.521C14.3333 37.0081 15.5337 38.2085 17.0208 38.2085H25.9792C27.4662 38.2085 28.6667 37.0081 28.6667 35.521C28.6667 34.0339 27.4662 32.8335 25.9792 32.8335ZM33.1458 16.7085H9.85417C8.36708 16.7085 7.16667 17.9089 7.16667 19.396C7.16667 20.8831 8.36708 22.0835 9.85417 22.0835H33.1458C34.6329 22.0835 35.8333 20.8831 35.8333 19.396C35.8333 17.9089 34.6329 16.7085 33.1458 16.7085Z",
    fill: "#B5B9BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterGrey);
export default __webpack_public_path__ + "static/media/filter-grey.b92e21877c3c47fd13c9ecb60a648e8f.svg";
export { ForwardRef as ReactComponent };